module.exports = __webpack_public_path__ + "static/media/IMG_7842.6756bb9d.JPG";